import status from '../../../../shared/functions/Status/status.dictionaries'
import { OfferRequestStatusChip, OfferRequestStatusSource } from './OfferRequestStatus.types'

/**
 * Order statuses that say more than the item statuses do. A cancelled order's items can be left at
 * whatever stage they were in when it was cancelled, so the order status is the one to show.
 */
const orderLevelStatuses: string[] = [status.offerRequestStatus.cancelled, status.offerRequestStatus.cancelled_by_admin]

/**
 * Works out which status chips an admin order list shows for an order.
 *
 * The order's own status stays "Accepted by Traveler" until delivery is confirmed, so on its own the
 * list contradicted the order details view, which shows each item's status. The list shows the item
 * statuses instead - one chip per stage, with how many items are at it when the order has more than
 * one item.
 *
 * @param offerRequest - The listed order, with its status and its item statuses.
 * @returns The chips to show, in order.
 */
export const getOfferRequestStatusChips = (offerRequest: OfferRequestStatusSource): OfferRequestStatusChip[] => {
  const { status: orderStatus, itemStatuses = [] } = offerRequest

  if (orderLevelStatuses.includes(orderStatus.name) || itemStatuses.length === 0) {
    return [{ name: orderStatus.name, label: orderStatus.displayName || orderStatus.name }]
  }

  const itemCount = itemStatuses.reduce((total, itemStatus) => total + itemStatus.count, 0)

  return itemStatuses.map((itemStatus) => {
    const label = itemStatus.displayName || itemStatus.name

    return {
      name: itemStatus.name,
      label: itemCount > 1 ? `${label} ×${itemStatus.count}` : label
    }
  })
}
